//import React, {useState, useEffect} from 'react';
import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import Product from "../components/Product";
//import {useDispatch,useSelector} from 'react-redux';
import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../actions/productActions";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { listMyOrders } from "../actions/orderActions";
import Hero from "../components/Hero";
import ProductsVision from "../components/productsVision";
import Paginate from "../components/Paginate";
import { useParams } from "react-router-dom";
import axios from "axios";

/* ───────────────────────────────────────────────────────────────────
   Local elegant SVG fallbacks for the section cards
   (used when no admin-uploaded image exists, or as a default
   on top of an existing cream-and-gold aesthetic)
   ─────────────────────────────────────────────────────────────────── */
import sectionPerfumesImg from "../img/section-perfumes.svg";
import sectionCosmeticosImg from "../img/section-cosmeticos.svg";
import sectionTodosImg from "../img/section-todos.svg";

/* ───────────────────────────────────────────────────────────────────
   SectionCard — restyled to match the Catálogo aesthetic
   (cream surface, gold accents, serif title, refined active state)
   Uses a div with role="button" to avoid native button text
   rendering quirks; content is absolutely positioned to the
   bottom so it never bleeds outside the card.
   ─────────────────────────────────────────────────────────────────── */
const SectionCard = ({ imgUrl, label, blurb, onClick, active = false }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-pressed={active}
      aria-label={label}
      className={`hadacy-section-card ${active ? "is-active" : ""}`}
    >
      <span className="hadacy-section-card__bg" aria-hidden="true">
        {imgUrl && (
          <img
            src={imgUrl}
            alt=""
            aria-hidden="true"
            className="hadacy-section-card__img"
          />
        )}
        <span className="hadacy-section-card__overlay" />
      </span>
      <span className="hadacy-section-card__content">
        {/* <span className="hadacy-section-card__kicker">Categoría</span> */}
        <span className="hadacy-section-card__title">{label}</span>
        {blurb && <span className="hadacy-section-card__blurb">{blurb}</span>}
        <span className="hadacy-section-card__cta">
          {active ? "Seleccionado" : "Explorar"}
        </span>
      </span>
    </div>
  );
};


const HomeScreen = () => {
  const productsRef = useRef(null);
  // Anchor for the inline search/filters block. We scroll here after a
  // search submit so the search bar stays visible (it was being pushed
  // off-screen by the mobile auto-scroll).
  const searchSectionRef = useRef(null);
  const { keyword } = useParams();
  const { pageNumber } = useParams() || 1;
  const [filterType, setFilterType] = useState("perfumes"); // "all" | "cosmeticos" | "perfumes" — default: PERFUMES
  // Track the previous filterType so we can tell *why* the data-loading
  // effect fired (category switch vs. search/pagination). We only auto-scroll
  // on a real category switch — never on a search or page change.
  const prevFilterTypeRef = useRef("perfumes");

  //const [products,setProducts] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const windowWidth = useRef(window.innerWidth);
  const productList = useSelector((state) => state.productList);
  const { loading, error, products, page, pages } = productList;

  const [perfumeFilters, setPerfumeFilters] = useState({
    mujer: false,
    hombre: false,
    unisex: false,
  });

  // Search input state — initialized from the URL :keyword, kept in sync if
  // the URL changes (e.g. browser back/forward, search from the header SearchBox).
  const [searchInput, setSearchInput] = useState(keyword || "");
  useEffect(() => {
    setSearchInput(keyword || "");
  }, [keyword]);

  // Smoothly bring the search bar back into view (offset a bit so the
  // sticky/fixed header above doesn't cover it). Used after submit/clear
  // so the user can always see — and edit — their current search.
  const scrollToSearchBar = () => {
    requestAnimationFrame(() => {
      if (!searchSectionRef.current) return;
      const y =
        searchSectionRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        90;
      window.scrollTo({ top: Math.max(y, 0), behavior: "smooth" });
    });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmed = searchInput.trim();
    if (trimmed) {
      navigate(`/search/${encodeURIComponent(trimmed)}`);
    } else if (keyword) {
      // Empty submit while a keyword was active → clear it
      navigate("/page/1");
    }
    // Keep the search bar visible after submit so the user can refine
    // or clear the search without having to refresh the page.
    scrollToSearchBar();
  };

  const handleClearSearch = () => {
    setSearchInput("");
    if (keyword) navigate("/page/1");
    scrollToSearchBar();
  };

  const [sectionImgs, setSectionImgs] = useState(null);   // { seccion1: {...}, seccion2: {...}, seccion3: {...} }

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get("/api/site-images?keys=seccion1,seccion2,seccion3");
        const map = data?.map || {};
        setSectionImgs(map);
      } catch (e) {
        setSectionImgs({}); // fail closed -> use local SVG fallbacks
      }
    })();
  }, []);

  const filteredProducts = products.filter((p) => {
    if (filterType === "all") return true;
    if (filterType === "cosmeticos") return p.tipo === "cosmeticos";

    // PERFUMES
    if (filterType === "perfumes") {
      if (p.tipo !== "perfumes") return false;

      const { mujer, hombre, unisex } = perfumeFilters;
      const filtrosActivos = [mujer, hombre, unisex].some(Boolean);

      if (!filtrosActivos) return true; // si no hay ninguno activo, mostrar todos

      return (
        (mujer && p.genero === "dama") ||
        (hombre && p.genero === "caballero") ||
        (unisex && p.genero === "unisex")
      );
    }

    return true;
  });


  const orderListMy = useSelector((state) => state.orderListMy);
  const { loading: loadingOrders, error: errorOrders, orders } = orderListMy;

  // Build a comma-separated genero string from perfumeFilters when filterType === 'perfumes'.
  // mujer -> dama, hombre -> caballero, unisex -> unisex.
  // If no checkboxes are active, send empty string (backend treats as "no filter").
  const generoParam =
    filterType === "perfumes"
      ? [
          perfumeFilters.mujer && "dama",
          perfumeFilters.hombre && "caballero",
          perfumeFilters.unisex && "unisex",
        ]
          .filter(Boolean)
          .join(",")
      : "";

  useEffect(() => {
    const saveVisitor = async () => {
      try {
        const { data } = await axios.get("https://ipapi.co/json/");
        await axios.post("/api/users/visitors", {
          Country: data.country_name,
          Region: data.region,
          Ciudad: data.city,
        });
      } catch { }
    };
    saveVisitor();

    if (filterType) {
      dispatch(listProducts(keyword, pageNumber, filterType, generoParam));
      dispatch(listMyOrders());

      // Only auto-scroll on mobile when the *category* itself changed
      // (e.g. user clicked a different SectionCard). We deliberately do NOT
      // scroll on keyword / pageNumber / genero changes — otherwise submitting
      // a search would push the search bar off-screen, which is exactly the
      // "search disappears after I search" problem we're fixing.
      const filterTypeChanged = prevFilterTypeRef.current !== filterType;
      prevFilterTypeRef.current = filterType;

      if (filterTypeChanged && window.innerWidth < 768 && productsRef.current) {
        requestAnimationFrame(() => {
          const y =
            productsRef.current.getBoundingClientRect().top +
            window.pageYOffset -
            70;
          window.scrollTo({ top: y, behavior: "smooth" });
        });
      }
    }
  }, [dispatch, keyword, pageNumber, filterType, generoParam]);

  /* Friendly label for the active filter (used in the intro copy) */
  const activeLabel =
    filterType === "perfumes" ? "Perfumes"
      : filterType === "cosmeticos" ? "Cosméticos"
        : filterType === "all" ? "Todo el catálogo"
          : "Selecciona una categoría";

  /* Resolve image URLs: prefer admin-uploaded site-image, otherwise use elegant local SVG */
  const perfumesImg =
    sectionImgs?.seccion1?.secureUrl ||
    sectionImgs?.seccion1?.url ||
    sectionPerfumesImg;
  const cosmeticosImg =
    sectionImgs?.seccion2?.secureUrl ||
    sectionImgs?.seccion2?.url ||
    sectionCosmeticosImg;
  const todosImg =
    sectionImgs?.seccion3?.secureUrl ||
    sectionImgs?.seccion3?.url ||
    sectionTodosImg;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Jost:wght@200;300;400;500&display=swap');

        /* Prevent the cream full-bleed sections from creating a horizontal scrollbar */
        body { overflow-x: hidden; }

        .hadacy-home {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --blush: #e8d5c4;
          --muted: #7a6e62;
          --card-bg: #faf7f2;

          background: var(--cream);
          color: var(--dark);
          font-family: "Jost", sans-serif;
          font-weight: 300;
          padding: 2.5rem 0 3rem;

          /* Full-bleed: extend cream background to the viewport edges,
             escaping any constrained parent (Bootstrap Container, etc.) */
          width: 100vw;
          position: relative;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;

          /* Pull the home section flush against the footer (negate <main className="py-3"> padding-bottom) */
          margin-bottom: -1rem;
        }

        .hadacy-home * { box-sizing: border-box; }

        .hadacy-home .hadacy-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        /* ─── Intro / Section heading ─── */
        .hadacy-home .hadacy-intro {
          text-align: center;
          max-width: 760px;
          margin: 0 auto 2.25rem;
        }
        .hadacy-home .hadacy-kicker {
          font-size: 0.7rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.55rem;
        }
        .hadacy-home .hadacy-intro h1 {
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(1.9rem, 4vw, 2.8rem);
          font-weight: 400;
          line-height: 1.05;
          color: var(--dark);
          margin: 0 0 0.7rem;
          letter-spacing: 0.01em;
        }
        .hadacy-home .hadacy-intro p {
          font-size: 0.92rem;
          line-height: 1.75;
          color: var(--muted);
          margin: 0 auto;
          max-width: 620px;
        }
        .hadacy-home .hadacy-divider {
          width: 60px;
          height: 1px;
          background: linear-gradient(90deg, transparent, var(--gold), transparent);
          margin: 1.1rem auto 0;
        }

        /* ─── Section cards row ─── */
        .hadacy-home .hadacy-cards-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1rem;
          margin-bottom: 2rem;
        }
        @media (max-width: 768px) {
          .hadacy-home .hadacy-cards-row { grid-template-columns: 1fr; }
        }

        .hadacy-section-card {
          position: relative;
          display: block;
          overflow: hidden;
          border-radius: 18px;
          height: 240px;
          width: 100%;
          cursor: pointer;
          background: var(--card-bg);
          border: 1px solid rgba(184,147,58,0.18);
          box-shadow: 0 10px 25px rgba(26,20,16,0.05);
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
          box-sizing: border-box;
          text-align: left;
          outline: none;
          -webkit-tap-highlight-color: transparent;
        }
        .hadacy-section-card:focus-visible {
          box-shadow:
            0 0 0 2px var(--gold),
            0 18px 38px rgba(26,20,16,0.12);
        }
        .hadacy-section-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 18px 38px rgba(26,20,16,0.12);
        }
        .hadacy-section-card.is-active {
          border-color: var(--dark);
          box-shadow:
            0 0 0 2px var(--dark),
            0 0 0 4px rgba(184,147,58,0.35),
            0 18px 38px rgba(26,20,16,0.18);
          animation: hadacyTilePulse 2.4s ease-in-out infinite;
        }

        .hadacy-section-card__bg {
          position: absolute;
          inset: 0;
          z-index: 0;
          overflow: hidden;
          border-radius: inherit;
          display: block;
        }
        .hadacy-section-card__img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform .55s ease, filter .35s ease;
          filter: saturate(0.95) brightness(0.96);
        }
        .hadacy-section-card:hover .hadacy-section-card__img { transform: scale(1.06); }
        .hadacy-section-card.is-active .hadacy-section-card__img {
          filter: saturate(1) brightness(0.82);
          transform: scale(1.04);
        }

        .hadacy-section-card__overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(26,20,16,0.05) 0%, rgba(26,20,16,0.78) 100%);
          display: block;
        }
        .hadacy-section-card.is-active .hadacy-section-card__overlay {
          background: linear-gradient(180deg, rgba(26,20,16,0.12) 0%, rgba(26,20,16,0.86) 100%);
        }

        /* Content is absolutely positioned at the bottom so it
           cannot leak above the card or stack improperly. */
        .hadacy-section-card__content {
          position: absolute;
          left: 1.4rem;
          right: 1.4rem;
          bottom: 1.4rem;
          z-index: 1;
          color: var(--cream);
          display: flex;
          flex-direction: column;
          gap: 0.45rem;
          align-items: flex-start;
          pointer-events: none; /* clicks fall through to the card */
        }
        .hadacy-section-card__kicker {
          font-size: 0.62rem;
          letter-spacing: 0.25em;
          text-transform: uppercase;
          color: var(--gold-light);
          font-weight: 400;
          display: block;
        }
        .hadacy-section-card__title {
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(1.7rem, 3vw, 2.25rem);
          font-weight: 400;
          letter-spacing: 0.04em;
          line-height: 1;
          color: #fff;
          display: block;
        }
        .hadacy-section-card__blurb {
          font-size: 0.82rem;
          line-height: 1.55;
          color: rgba(245,240,232,0.86);
          max-width: 90%;
          display: block;
        }
        .hadacy-section-card__cta {
          margin-top: 0.4rem;
          padding: 0.45rem 0.9rem;
          border: 1px solid rgba(212,175,106,0.55);
          color: var(--gold-light);
          font-size: 0.66rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          border-radius: 999px;
          background: rgba(26,20,16,0.35);
          display: inline-block;
        }
        .hadacy-section-card.is-active .hadacy-section-card__cta {
          background: var(--gold);
          color: var(--dark);
          border-color: var(--gold);
        }

        @keyframes hadacyTilePulse {
          0%, 100% { box-shadow: 0 0 0 2px var(--dark), 0 0 0 4px rgba(184,147,58,0.35), 0 18px 38px rgba(26,20,16,0.18); }
          50%      { box-shadow: 0 0 0 2px var(--dark), 0 0 0 8px rgba(184,147,58,0.20), 0 18px 38px rgba(26,20,16,0.18); }
        }

        /* ─── Inline search bar ─── */
        .hadacy-home .hadacy-search {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          margin: 0 auto 1.4rem;
          max-width: 560px;
          padding: 0.35rem 0.4rem 0.35rem 1rem;
          background: var(--card-bg);
          border: 1px solid rgba(184,147,58,0.3);
          border-radius: 999px;
          transition: border-color .2s ease, box-shadow .2s ease;
        }
        .hadacy-home .hadacy-search:focus-within {
          border-color: var(--gold);
          box-shadow: 0 0 0 3px rgba(184,147,58,0.12);
        }
        .hadacy-home .hadacy-search-icon {
          color: var(--gold);
          font-size: 0.95rem;
          line-height: 1;
        }
        .hadacy-home .hadacy-search input {
          flex: 1;
          min-width: 0;
          border: none;
          background: transparent;
          outline: none;
          font-family: "Jost", sans-serif;
          font-size: 0.92rem;
          color: var(--dark);
          padding: 0.45rem 0.25rem;
        }
        .hadacy-home .hadacy-search input::placeholder {
          color: var(--muted);
          font-style: italic;
        }
        .hadacy-home .hadacy-search-clear {
          background: transparent;
          border: none;
          color: var(--muted);
          font-size: 1.1rem;
          line-height: 1;
          padding: 0 .25rem;
          cursor: pointer;
        }
        .hadacy-home .hadacy-search-clear:hover { color: var(--dark); }
        .hadacy-home .hadacy-search-submit {
          border: none;
          border-radius: 999px;
          padding: 0.45rem 1rem;
          background: var(--dark);
          color: var(--gold-light);
          font-size: 0.68rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          cursor: pointer;
          transition: background .2s ease, color .2s ease;
        }
        .hadacy-home .hadacy-search-submit:hover {
          background: var(--gold);
          color: var(--dark);
        }
        .hadacy-home .hadacy-active-search-wrap {
          display: flex;
          justify-content: center;
          margin-bottom: 1rem;
        }
        .hadacy-home .hadacy-active-search {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          padding: 0.35rem 0.85rem;
          border: 1px solid rgba(184,147,58,0.35);
          border-radius: 999px;
          font-size: 0.72rem;
          letter-spacing: 0.08em;
          color: var(--muted);
          background: var(--card-bg);
        }
        .hadacy-home .hadacy-active-search strong { color: var(--dark); }
        .hadacy-home .hadacy-active-search button {
          border: none;
          background: none;
          cursor: pointer;
          color: var(--gold);
          font-size: 1rem;
          line-height: 1;
          padding: 0;
        }
        .hadacy-home .hadacy-active-search button:hover { color: var(--dark); }

        /* ─── Perfume sub-filters (mujer/hombre/unisex) ─── */
        .hadacy-home .hadacy-subfilters {
          display: flex;
          gap: 0.55rem;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 2rem;
        }
        .hadacy-home .hadacy-subfilter {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.5rem 1.05rem;
          border: 1px solid rgba(184,147,58,0.3);
          border-radius: 999px;
          background: var(--card-bg);
          font-size: 0.72rem;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: var(--muted);
          cursor: pointer;
          transition: all .2s ease;
          user-select: none;
        }
        .hadacy-home .hadacy-subfilter:hover {
          color: var(--dark);
          border-color: var(--gold);
        }
        .hadacy-home .hadacy-subfilter.is-checked {
          background: var(--dark);
          color: var(--gold-light);
          border-color: var(--dark);
        }
        .hadacy-home .hadacy-subfilter input { display: none; }
        .hadacy-home .hadacy-subfilter .dot {
          width: 8px; height: 8px;
          border-radius: 999px;
          border: 1px solid currentColor;
          background: transparent;
        }
        .hadacy-home .hadacy-subfilter.is-checked .dot {
          background: var(--gold-light);
          border-color: var(--gold-light);
        }

        /* ─── Sub-section header (above results) ─── */
        .hadacy-home .hadacy-section-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin: 0.5rem 0 1.25rem;
        }
        .hadacy-home .hadacy-section-header h2 {
          font-family: "Cormorant Garamond", serif;
          font-weight: 300;
          font-size: clamp(1.3rem, 3vw, 1.85rem);
          letter-spacing: 0.12em;
          color: var(--dark);
          margin: 0;
          white-space: nowrap;
          text-transform: uppercase;
        }
        .hadacy-home .hadacy-section-header .line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, rgba(184,147,58,0.35), transparent);
        }
        .hadacy-home .hadacy-section-header .count {
          font-size: 0.72rem;
          color: var(--muted);
          letter-spacing: 0.12em;
        }

        /* ─── Products area + Bootstrap card overrides ─── */
        .hadacy-home .hadacy-products-wrap {
          position: relative;
          padding-top: 0.25rem;
        }
        .hadacy-home .hadacy-loader-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(245,240,232,0.7);
          z-index: 1;
          border-radius: 12px;
        }
        .hadacy-home .hadacy-products-wrap .card {
          background: var(--card-bg) !important;
          border: 1px solid rgba(184,147,58,0.18) !important;
          border-radius: 18px !important;
          box-shadow: 0 10px 25px rgba(26,20,16,0.04);
          transition: transform .25s ease, box-shadow .25s ease;
        }
        .hadacy-home .hadacy-products-wrap .card:hover {
          transform: translateY(-3px);
          box-shadow: 0 18px 38px rgba(26,20,16,0.10);
        }
        .hadacy-home .hadacy-products-wrap .card a { color: var(--dark) !important; }
        .hadacy-home .hadacy-products-wrap .card a:hover { color: var(--gold) !important; }
        .hadacy-home .hadacy-products-wrap .card-title strong { font-family: "Cormorant Garamond", serif; font-weight: 400; font-size: 1.15rem; }
        .hadacy-home .hadacy-products-wrap h3 { color: var(--gold); font-weight: 500; font-size: 1.05rem; letter-spacing: 0.04em; }

        /* ─── Pagination tweak ─── */
        .hadacy-home .hadacy-pagination { margin-top: 2.5rem; }

        /* ─── Empty state ─── */
        .hadacy-home .hadacy-empty {
          text-align: center;
          padding: 3rem 1.5rem;
          color: var(--muted);
          font-style: italic;
          font-family: "Cormorant Garamond", serif;
          font-size: 1.15rem;
        }
      `}</style>

      <Hero />
      <ProductsVision />

      <div className="hadacy-home">
        <div className="hadacy-container">
          {/* ── Intro ── */}
          <div className="hadacy-intro">
            <p className="hadacy-kicker">Catálogo HADACY</p>
            <h1>Nuestros productos</h1>
            <p>
              Elige por categoría y descubre nuestra selección de perfumes y
              cosméticos.
            </p>
            <div className="hadacy-divider" />
          </div>

          {/* ── Section cards (always rendered with elegant SVG fallbacks) ── */}
          <div id="hadacy-explore" className="hadacy-cards-row">
            <SectionCard
              imgUrl={perfumesImg}
              label="PERFUMES"
              blurb="Mujer, Hombre y Unisex."
              active={filterType === "perfumes"}
              onClick={() => {
                setFilterType("perfumes");
                navigate("/page/1");
              }}
            />
            <SectionCard
              imgUrl={cosmeticosImg}
              label="COSMÉTICOS"
              blurb="Cuidado y tratamiento para tu piel."
              active={filterType === "cosmeticos"}
              onClick={() => {
                setFilterType("cosmeticos");
                navigate("/page/1");
              }}
            />
            <SectionCard
              imgUrl={todosImg}
              label="TODOS"
              blurb="Explora todo el catálogo."
              active={filterType === "all"}
              onClick={() => {
                setFilterType("all");
                navigate("/page/1");
              }}
            />
          </div>

          {/* ── Inline search (wrapped so we can scroll back to it after submit) ── */}
          <div ref={searchSectionRef} className="hadacy-search-section">
            <form
              className="hadacy-search"
              role="search"
              onSubmit={handleSearchSubmit}
            >
              <span className="hadacy-search-icon" aria-hidden="true">⌕</span>
              <input
                type="search"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder='Buscar por nombre, marca, nota o aroma (ej: "Ariana", "floral", "almizcle")'
                aria-label="Buscar productos"
              />
              {searchInput && (
                <button
                  type="button"
                  className="hadacy-search-clear"
                  onClick={handleClearSearch}
                  aria-label="Limpiar búsqueda"
                  title="Limpiar"
                >
                  ×
                </button>
              )}
              <button type="submit" className="hadacy-search-submit">
                Buscar
              </button>
            </form>

            {/* Active-search chip — visible whenever a :keyword is in the URL */}
            {keyword && (
              <div className="hadacy-active-search-wrap">
                <span className="hadacy-active-search">
                  Resultados para <strong>"{keyword}"</strong>
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    aria-label="Quitar búsqueda"
                    title="Quitar búsqueda"
                  >
                    ×
                  </button>
                </span>
              </div>
            )}
          </div>

          {/* ── Perfume sub-filters ── */}
          {filterType === "perfumes" && (
            <div className="hadacy-subfilters">
              {["mujer", "hombre", "unisex"].map((option) => {
                const checked = perfumeFilters[option];
                return (
                  <label
                    key={option}
                    className={`hadacy-subfilter ${checked ? "is-checked" : ""}`}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => {
                        setPerfumeFilters((prev) => ({
                          ...prev,
                          [option]: !prev[option],
                        }));
                        // Reset to page 1 so the user doesn't land on a page
                        // that no longer exists in the filtered result set.
                        if (pageNumber && Number(pageNumber) !== 1) {
                          navigate("/page/1");
                        }
                      }}
                    />
                    <span className="dot" />
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </label>
                );
              })}
            </div>
          )}

          {/* ── Section header above results ── */}
          {filterType && (
            <div className="hadacy-section-header">
              <h2>{activeLabel}</h2>
              <div className="line" />
              <span className="count">{filteredProducts.length}</span>
            </div>
          )}

          {/* ── Errors ── */}
          {error && <Message variant="danger">{error}</Message>}

          {/* ── Products grid ── */}
          <div ref={productsRef} className="hadacy-products-wrap">
            {loading && (
              <div className="hadacy-loader-overlay">
                <Loader />
              </div>
            )}

            {!loading && filterType && filteredProducts.length === 0 ? (
              <div className="hadacy-empty">
                No encontramos productos en esta categoría.
              </div>
            ) : (
              <Row className="d-flex justify-content-center" aria-busy={loading}>
                {filteredProducts.map((product) => (
                  <Col className="mt-2 mb-2" key={product._id} sm={12} md={6} lg={4} xl={4}>
                    <Product product={product} />
                  </Col>
                ))}
              </Row>
            )}
          </div>

          {/* ── Pagination ── */}
          <Row className="d-flex justify-content-center hadacy-pagination">
            <Paginate pages={pages} page={page} keyword={keyword ? keyword : ""} />
          </Row>
        </div>
      </div>
    </>
  );
};

export default HomeScreen;
